import React from 'react'
import { Link } from 'components'

interface IShareButtonProps {
  link: string
  name: string
  icon: JSX.Element
  onClick: (e: React.MouseEvent) => void
  display?: string
  margin?: string
}

const ShareButton = ({ link, name, icon, ...rest }: IShareButtonProps) => {
  return (
    <Link
      display='inline-flex'
      margin='12px 12px 0 12px'
      href={link}
      target='_blank'
      rel='noreferrer noopener'
      aria-label={`Share on ${name}`}
      title={`Share on ${name}`}
      {...rest}
    >
      {icon}
    </Link>
  )
}

export default ShareButton
